import { makeRequest } from 'services/request.service'

export const listUsers = () =>
  makeRequest({ method: 'GET', url: '/users' })

export const createUser = (payload) =>
  makeRequest({ method: 'POST', url: '/users', data: payload })

export const updateUser = (id, payload) =>
  makeRequest({ method: 'PUT', url: `/users/${id}`, data: payload })

export const deleteUser = (id) =>
  makeRequest({ method: 'DELETE', url: `/users/${id}` })

export const listClients = () =>
  makeRequest({ method: 'GET', url: '/clients' })

export const createClient = (name) =>
  makeRequest({ method: 'POST', url: '/clients', data: { name } })

export const updateClient = (id, payload) =>
  makeRequest({ method: 'PATCH', url: `/clients/${id}`, data: payload })
